import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubFeatureModel = types
  .model("EPubFeatureModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FEATURING_EPUB_BOOK");
    },
    set(response) {
      let status = response.status;
      let data;
      if (status === 204) {
        data = `The book has been marked as featured successfully.`;
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res:"Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EPubFeatureModel;
